export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1';

export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;
export const PAGE_SIZES = [10, 20, 50, 100] as const;

export const STALE_TIME = 5 * 60 * 1000; // 5 minutes

export const TOKEN_REFRESH_THRESHOLD = 5 * 60 * 1000; // 5 minutes before expiry

export const SIDEBAR_MINI_WIDTH = 56;
export const SIDEBAR_PANEL_WIDTH = 240;

export const RISK_MATRIX_SIZE = 5;
